import React, { useEffect } from 'react';
import { Dialog, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { DialogContentWithoutClose } from "../ui/custom-dialog";
import { Button } from "../ui/button";
import { PartyPopper } from 'lucide-react';
import { refreshManager } from '../../services/refreshManager';
import confetti from 'canvas-confetti';

interface SuccessDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAddAnother: () => void;
}

export function SuccessDialog({ open, onOpenChange, onAddAnother }: SuccessDialogProps) {
  // Handle dialog close
  const handleClose = () => {
    // Close this dialog
    onOpenChange(false);
    // End session to trigger syncs
    refreshManager.endSession();
    // Signal parent to close add dialog
    window.dispatchEvent(new CustomEvent('closeAddGoodThingDialog'));
  };

  // Handle add another
  const handleAddAnother = () => {
    // First call onAddAnother to prepare the add dialog
    onAddAnother();
    // Then close this dialog
    onOpenChange(false);
  };

  // Trigger confetti effect when dialog opens
  useEffect(() => {
    if (open) {
      // Create a dramatic confetti effect
      
      // Center burst
      confetti({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.7, x: 0.5 }
      });
      
      // Left cannon
      setTimeout(() => {
        confetti({
          particleCount: 80,
          angle: 60,
          spread: 50,
          origin: { x: 0, y: 0.7 }
        });
      }, 250);
      
      // Right cannon
      setTimeout(() => {
        confetti({
          particleCount: 80,
          angle: 120,
          spread: 50,
          origin: { x: 1, y: 0.7 }
        });
      }, 400);
      
      // Final burst
      setTimeout(() => {
        confetti({
          particleCount: 120,
          spread: 120,
          origin: { y: 0.6, x: 0.5 }
        });
      }, 650);
    }
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContentWithoutClose className="sm:max-w-[425px] dark:bg-gray-800 dark:border-gray-700">
        <DialogHeader>
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-pink-100 dark:bg-pink-900">
            <PartyPopper className="h-6 w-6 text-pink-600 dark:text-pink-300" />
          </div>
          <DialogTitle className="text-center dark:text-white">Thanks for spreading joy!</DialogTitle>
          <DialogDescription className="text-center dark:text-gray-400">
            Your Good Thing is being recorded in our magical backend. It'll appear in the feed faster than you can say "positivity"! (Well, maybe a few more times than that... give it about 30 seconds.)
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center space-x-4">
          <Button 
            onClick={handleClose}
            variant="outline"
            className="dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:bg-gray-600"
          >
            Close
          </Button>
          <Button 
            onClick={handleAddAnother}
            className="bg-pink-600 hover:bg-pink-700"
          >
            Add Another Good Thing
          </Button>
        </div>
      </DialogContentWithoutClose>
    </Dialog>
  );
}

export default SuccessDialog;
